import React from 'react';

import styles from './firmReferencesStyles';

import Link from 'buyside/components/presentation/Link/link';

import BriefcaseIcon from 'buyside/svgs/briefcase.svg';
import EnvelopeIcon from 'buyside/svgs/envelope.svg';

const FirmReferences = ({ fundProfile, createAuditRecord }) => {
  const { firmReferences } = fundProfile;
  return (
    <div>
      <div className={styles.firmReferencesIntro}>
        <em>
          The following individuals have been listed by the firm as willing to speak to the
          professional and personal character of the people who work there. They have agreed to be
          contacted in this regard.
        </em>
      </div>
      <ul className={styles.firmReferencesList}>
        {firmReferences.map((reference, idx) => (
          <li key={idx}>
            <h4>{reference.name}</h4>
            <div className={styles.firmReferenceContactInfo}>
              <span>
                <BriefcaseIcon className={styles.firmReferenceIcon} />
                <span>
                  {reference.title} at {reference.employer}
                </span>
              </span>
              <span>
                <EnvelopeIcon />
                <Link
                  to={`mailto:${reference.contactEmail}`}
                  onMouseDown={() =>
                    createAuditRecord(reference.id, 'EmployerProfileFirmReference', 'mailto_click')
                  }
                >
                  {reference.contactEmail}
                </Link>
              </span>
            </div>
            <div className={styles.firmReferenceRelationship}>
              <em>"{reference.relationshipToFund}"</em>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FirmReferences;
